"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPreferencesService = void 0;
var preference_client_builder_1 = require("@greatmindsorg/dp-user-preferences-sdk/dist/src/clients/builder/preference-client.builder");
var UserPreferencesService = /** @class */ (function () {
    function UserPreferencesService() {
    }
    /**
     * Get the instance of user preference api
     *
     * @returns {PreferenceClient}
     */
    UserPreferencesService.getInstance = function (platform) {
        if (!UserPreferencesService.instance) {
            UserPreferencesService.instance = preference_client_builder_1.PreferenceClientBuilder.getClient({
                hostURL: "".concat(window.location.origin, "/"),
                platform: platform,
            });
        }
        return UserPreferencesService.instance;
    };
    /**
     * Sets the user preferences
     * @param {string} key               Key of value to be stored
     * @param {T} preferenceValue        Value to be stored
     * @param platform                   Platform to retrieve preferences from
     * @returns {Promise<T>}
     */
    UserPreferencesService.prototype.setUserPreferences = function (key, preferenceValue, platform) {
        if (platform === void 0) { platform = ''; }
        return UserPreferencesService.getInstance(platform)
            .setItem(key, preferenceValue)
            .catch(function () { return null; });
    };
    /**
     * Gets the user preferences from api
     *
     * @param {string} key      Key of value to be retrieved
     * @param platform          Platform to retrieve preferences from
     * @returns {Promise<PreferenceValueDto>}
     */
    UserPreferencesService.prototype.getUserPreferences = function (key, platform) {
        if (platform === void 0) { platform = ''; }
        return UserPreferencesService.getInstance(platform)
            .getItem(key)
            .catch(function () { return null; });
    };
    return UserPreferencesService;
}());
exports.UserPreferencesService = UserPreferencesService;
